module.exports = __webpack_public_path__ + "img/17.b9d5b69e.png";